import { Survey } from './types';

const defaultState: Survey.ModuleState = {
  isLoading: false,
  isSurveySubmitted: false,
  surveyData: null,
  activeStep: 1,
};

export default defaultState;
